<template>

  <b-card>


    <b-row class="mb-1">
      <b-col md="4">
        <b-form-input placeholder="Cari" v-model="filter.employeeName" />
      </b-col>
      <b-col class="text-right">
        <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        :disabled="isLoadingGenerate"
        @click="generate()"
        class="mr-2"
      >
        <b-spinner class="mr-1" small variant="light" v-if="isLoadingGenerate" />
        Generate Cuti
      </b-button>
        <b-button
          v-b-modal.form-employee-paid-leave-modal
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="cleanUpForm()">
          Tambah
        </b-button>
      </b-col>
    </b-row>

    <BaseTable
      :fields="fields"
      :items="items"
      :loading="loading"
      :rows="pagination.total"
      :perPage="filter.size"
      :currentPage="filter.page"
      :handle-page-change="handlePageChange"
      :detail-item="detailItem"
      :edit-item="editItem"
      :delete-item="deleteItem"
    />

    <FormEmployeePaidLeave
      :page-title="pageTitle"
      :loading="loading"
      :edit-id="editId"
      :create-item="createItem"
      :update-item="updateItem"
      :formPayload="formPayload"
      @formPayloadEmployeePaidLeave="getPayload($event)" />

    <DetailEmployeePaidLeave
      :page-title="pageTitle"
      :result="detail" />

  </b-card>

  </template>

  <script>
  import _ from "lodash";
  import Ripple from "vue-ripple-directive";

  import { EmployeePaidLeaveService } from '@/services/employee-paid-leave.service'

  import { BCard, BRow, BCol, BButton, BFormInput } from "bootstrap-vue";
  import { successNotification, errorNotification } from "@/auth/utils";

  import BaseTable from "@/components/BaseTable.vue";
  import FormEmployeePaidLeave from "@/components/EmployeePaidLeave/FormEmployeePaidLeave.vue";
  import DetailEmployeePaidLeave from "@/components/EmployeePaidLeave/DetailEmployeePaidLeave.vue";

  export default {
    name: 'EmployeePaidLeavePage',

    components: {
      BaseTable,
      BCard,
      BRow,
      BCol,
      BButton,
      BFormInput,
      FormEmployeePaidLeave,
      DetailEmployeePaidLeave
  },

    directives: {
      Ripple,
    },

    watch: {
      filter: {
        handler: _.debounce(function (value) {
          this.fetchData();
        }, 300),
        deep: true,
      },
    },

    setup () {
      return {
        successNotification,
        errorNotification,
        BaseTable,
      };
    },

    data () {
      return {
        pageTitle: 'Kuota Cuti Karyawan',
        items: [],
        detail: Object,
        error: false,
        loading: false,
        pagination: {
          total: 0
        },
        filter: {
          employeeName: "",
          paidLeaveId: this.$route.params.id,
          page: 1,
          size: 10
        },
        fields: [
          {
            key: "no",
            label: "No",
          },
          {
            key: "employee",
            label: "Nama Karyawan",
          },
          {
            key: "paidLeaveLeft",
            label: "Kuota Cuti",
          },
          {
            key: "actions",
            label: "Aksi",
          },
        ],
        editId: null,
        formPayload: Object,
        isLoadingGenerate: false
      }
    },

    methods: {
      cleanUpForm() {
        this.editId = null;
        this.formPayload = {
          employeeId: "",
          // employeePaidLeaveId: 0,
          // endDate: "",
          // isActive: true,
          paidLeaveId: this.$route.params.id,
          paidLeaveLeft: "",
          // startDate: ""
        };
      },
      generate() {
        const form = { periodId: this.$route.params.id };
        this.isLoadingGenerate = true;

        this.$http
          .get('/employee/paid-leave/generate/' + this.$route.params.id)
          .then((response) => {
            if (response.data.code !== '00' ) {
              errorNotification(this, "Oops!", response.data.message);
            } else {
              this.getData();
              this.cleanUpForm();
            }

            this.isLoadingGenerate = false;
          })
          .catch((error) => {
            errorNotification(this, "Oops!", error.response.data.message);
            this.isLoadingGenerate = false;
          });
      },
      async fetchData () {
        this.loading = true
        try {
          const { data } = await EmployeePaidLeaveService.findAll(this.filter)
          this.items = data.content
          this.pagination.total = data.total
        } catch (e) {
          this.error = e.message
          // errorNotification(this, "Oops!", e.message);
        } finally {
          this.loading = false
        }
      },
      detailItem(item) {
        this.detail = item;
        this.$bvModal.show('detail-employee-paid-leave-modal')
      },
      editItem(item) {
        this.editId = item.employeePaidLeaveId;
        this.formPayload = {
          employeeId: item.employee ? item.employee.employeeId : null,
          endDate: item.endDate,
          isActive: item.isActive,
          paidLeaveId: item.paidLeave ? item.paidLeave.category.paramListId : null,
          paidLeaveLeft: item.paidLeaveLeft,
          startDate: item.startDate
        };
        this.showFormModal()
      },
      async createItem() {
        this.loading = true

        try {
          await EmployeePaidLeaveService.create(this.formPayload)
          successNotification(this, "Success", `${this.pageTitle} berhasil dibuat!`);
          this.hideFormModal()
          this.fetchData()
        } catch (e) {
          this.error = e.message
          errorNotification(this, "Oops!", e.message);
        } finally {
          this.loading = false
        }
      },
      async updateItem() {
        this.loading = true

        try {
          await EmployeePaidLeaveService.update(this.editId, this.formPayload)
          successNotification(this, "Success", `${this.pageTitle} berhasil diubah!`);
          this.hideFormModal()
          this.fetchData()
        } catch (e) {
          this.error = e.message
          errorNotification(this, "Oops!", e.message);
        } finally {
          this.loading = false
        }
      },
      deleteItem(item) {
        this.$swal({
          title: "Anda yakin?",
          text: "Anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        }).then(async (result) => {
          if (result.value) {
            try {
              await EmployeePaidLeaveService.delete(item.employeePaidLeaveId)
              successNotification(this, "Success", `${this.pageTitle} berhasil dihapus!`);
              this.hideFormModal()
              this.fetchData()
            } catch (e) {
              this.error = e.message
              errorNotification(this, "Oops!", e.message);
            } finally {
              this.loading = false
            }
          }
        });
      },
      getPayload(value) {
        if (value) {
          this.formPayload = value;
        }
      },
      preparePayload() {
        const form = new FormData();
        for (const key in this.formPayload) {
          if (
            this.formPayload.hasOwnProperty(key) &&
            this.formPayload[key] != null
          ) {
            form.append(key, this.formPayload[key]);
          }
        }

        return form;
      },
      showFormModal() {
        this.$bvModal.show("form-employee-paid-leave-modal");
      },
      hideFormModal() {
        this.$bvModal.hide("form-employee-paid-leave-modal");
      },
      handlePageChange(value) {
        this.loading = true
        this.filter.page = value;
      },
    },

    created () {
      this.fetchData()
    }

  }

  </script>
